import initFontAwesome from "init/font-awesome";
import registerServiceWorker from "init/register-service-worker";
import { getIdentity } from "init/tracking";
import * as React from "react";
import * as ReactDOM from "react-dom";
import rollBar from "utils/rollbar";
import version from "version";
import Router from "./router";

initFontAwesome();
getIdentity().then(identity => {
  console.info(
    `Application launch. Device identity: ${identity}, Code revision: ${version}`
  );
  // TODO: Pass these as payload
  rollBar.info("Application launch.", {
    deviceFingeprint: identity,
    codeRevision: version
  });
});

ReactDOM.render(<Router />, document.getElementById("root") as HTMLElement);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.tsx